import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import MDBootstrapInputRoot from 'components/MDInputBootstrap/MDInputBootstrapRoot';

const MDBootstrapInput = forwardRef(
  ({ error = false, success = false, disabled = false, ...rest }, ref) => (
    <MDBootstrapInputRoot
      {...rest}
      ref={ref}
      ownerState={{ error, success, disabled }}
    />
  )
);

MDBootstrapInput.displayName = 'MDBootstrapInput';

// Typechecking props for the MDInput
MDBootstrapInput.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default MDBootstrapInput;
